import type { LeaveRequestData } from "@spork/s4p-server-sdk";

export type LeaveRequestType = LeaveRequestData["reason"];

/** Stable keys for leave reasons — translate via `leave.reasons.<key>`. */
export const LEAVE_REQUEST_TYPES = [
    "family_emergency",
    "holiday",
    "illness",
    "medical_appointment",
    "visa_residency_appointment",
    "extracurricular",
] as const satisfies readonly LeaveRequestType[];

/** Reasons that may only cover a single calendar day. */
export const SINGLE_DAY_LEAVE_REQUEST_TYPES = [
    "family_emergency",
    "medical_appointment",
    "visa_residency_appointment",
] as const satisfies readonly LeaveRequestType[];

export function isSingleDayLeaveRequestType(
    reason: LeaveRequestType,
): reason is (typeof SINGLE_DAY_LEAVE_REQUEST_TYPES)[number] {
    return (SINGLE_DAY_LEAVE_REQUEST_TYPES as readonly string[]).includes(reason);
}
